import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ResetPasswordForm from './ResetPasswordForm';
import { updatePassword } from '../../api/api';

export default class ResetPasswordPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      validResetPwd: false,
      errorMessage: '',
      spinner: 'inactive'
    }
  }

  onSubmit = (data) => {
    this.setState({ spinner: 'active' });
    data.userId = this.props.match.params.user;
    updatePassword(data).then((response) => {
      setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
        this.setState({ validResetPwd: true, errorMessage: '' });
    }, error => {
      this.setState({ errorMessage: 'Changement de mot de passe refusé' });
      setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
      console.log(error);
    })

  };

  render() {
    return (
      <div className="login-main reset-page">
        <div className="page-background"></div>
        <div className="container login-container">
          <div className="bloc-form">
            <h2>Modifier le mot de passe </h2>
            {!this.state.validResetPwd ?
              <ResetPasswordForm
                onSubmit={this.onSubmit}
                spinner={this.state.spinner}
              />
              :
              <div className="bloc-from_success">
                <img src='/images/yes.png' alt="image" />
                <p className="validation-txt">
                  Votre mot de passe a bien été modifié. Vous pouvez maintenant
                  vous connecter à votre espace de recueil de mémoire.
                    </p>
                  <Link to="/"><button type="button" className="btn btn-primary btn-lg">Me connecter</button></Link>
              </div>
            }
            <div className="bloc-form_error">
              {this.state.errorMessage &&
                <div className="alert alert-danger single-line" role="alert">{this.state.errorMessage}</div>
              }
            </div>
          </div>
          <div className="signon-container">
            <div className="col-sm-5 text-bloc">
              <h2>Mot de passe oublié ?</h2>
              <p className>Vous avez demandé la réinitialisation de votre mot de passe.
              <br /><br />
              Si vous n'êtes pas à l'origine de cette demande, vous n'avez rien à faire.
              <br /><br /> 
              Sinon merci de saisir un nouveau mot de passe et le code de validation reçu par email.
              </p>              
            </div>
          </div>
        </div>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/LoginPage/ResetPasswordPage.js